module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_5010.ffa16a89.png";